export const RESERVED_WORDS = [
  "sin",
  "cos",
  "tan",
  "log",
  "log2",
  "log10",
  "exp",
  "sqrt",
  "abs",
  "ceil",
  "floor",
  "round",
  "min",
  "max",
  "pow",
  "sign",
  "pi",
  "e",
  "random",
  "randomInt",
  "randomRange",
  "sigmoid",
  "sigmoid_sum",
  "arrSum",
  "arrAvg",
  "arrCount",
  "arrFirst",
  "arrLast",
  "arrMin",
  "arrMax",
  "arrFilter",
  "arrMap",
  "arrReduce",
  "arrGet",
  "arrContains",
  "duration",
  "victory",
]
